<h2 mat-dialog-title> {{fecha}}h</h2>
<mat-dialog-content>

    <img src="{{foto}}" class="imatge">

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="deleteImage()" >Eliminar</button>
  <button mat-raised-button (click)="close()" color="primary">Cerrar</button>
</mat-dialog-actions>
